import {SimpleSizeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutSizeSimple} from '@aboutyou/ui-components';
import React from 'react';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: SimpleSizeFilterSection;
  setFilter: ({
    filterId,
    filterSection,
  }: {
    filterId: string;
    filterSection: string;
  }) => void;
  enableFlyoutFilter: boolean;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
};

export const FilterSectionSizeSimple: React.FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  enableFlyoutFilter,
  hide,
  isOpen,
  open,
  submit,
}) => {
  const {label, slug, sizes} = data;
  const normalizedSizes = sizes.map(({id, label}) => ({
    id: `${id}`,
    label,
  }));

  const activeSlugFilters = activeFilters.get(slug) ?? [];

  return (
    <FilterFlyoutSizeSimple
      hide={hide}
      isOpen={isOpen}
      open={open}
      submit={submit}
      activeSizeIds={activeSlugFilters}
      key={`filter-flyout-size-${slug}`}
      label={label}
      enableFlyoutFilter={enableFlyoutFilter}
      onSizeClick={id => {
        setFilter({
          filterId: id,
          filterSection: slug,
        });
      }}
      sizes={normalizedSizes}
    />
  );
};
